'use strict';

const cssConstants = require('../utils/cssConstants');

// Mirror of passwordPolicyHelper.js — keep in sync.
const MIN_LENGTH = 12;

const STRENGTH_MODIFIERS = 'is-weak is-medium is-strong';
const STRENGTH_LEVELS = {
    weak: { width: '33%', modifier: 'is-weak' },
    medium: { width: '66%', modifier: 'is-medium' },
    strong: { width: '100%', modifier: 'is-strong' }
};

const $cache = {
    passwordField: $('.js-password'),
    currentPasswordField: $('.js-current-password'),
    passwordHelper: $('.js-password-helper'),
    passwordHelperList: $('.js-password-helper-list'),
    pwdLength: $('.js-pwd-length'),
    pwdUpper: $('.js-pwd-upper'),
    pwdLetter: $('.js-pwd-letter'),
    pwdNumber: $('.js-pwd-number'),
    pwdSpecial: $('.js-pwd-special'),
    strength: $('.js-password-strength'),
    strengthFill: $('.js-password-strength-fill'),
    strengthLabel: $('.js-password-strength-label')
};

/**
 * Resolves the strength tier from the satisfied checks; "strong" requires every rule met,
 * so the bar never contradicts an invalid field.
 * @param {string} pwdVal - The current password value.
 * @param {Object} checks - Satisfied policy checks (length/upper/lower/number/special).
 * @returns {(string|null)} The tier ('weak'|'medium'|'strong'), or null when empty.
 */
function getStrength(pwdVal, checks) {
    if (!pwdVal.length) {
        return null;
    }
    var satisfied = [checks.length, checks.upper, checks.lower, checks.number, checks.special]
        .filter(Boolean).length;
    if (satisfied === 5) {
        return 'strong';
    }
    return satisfied <= 3 ? 'weak' : 'medium';
}

/**
 * Renders the strength meter bar width, color modifier and label.
 * @param {(string|null)} strength - The strength tier, or null to reset/hide.
 * @returns {void}
 */
function renderStrength(strength) {
    if (!$cache.strength.length) {
        return;
    }
    if (!strength) {
        $cache.strength.addClass(cssConstants.HIDDEN);
        $cache.strengthFill.removeClass(STRENGTH_MODIFIERS).css('width', '0');
        $cache.strengthLabel.text('');
        return;
    }
    var level = STRENGTH_LEVELS[strength];
    var prefix = $cache.strength.data('label-prefix') || '';
    var label = $cache.strength.data('label-' + strength) || '';
    $cache.strength.removeClass(cssConstants.HIDDEN);
    $cache.strengthFill.removeClass(STRENGTH_MODIFIERS).addClass(level.modifier).css('width', level.width);
    $cache.strengthLabel.text((prefix + ' ' + label).trim());
}

module.exports = {
    passwordValidation: function () {
        $cache.passwordField.on('blur keyup', function () {
            var pwdVal = $cache.passwordField.val();
            var $formGroup = $cache.passwordField.parents('.form-group');
            var $fieldError = $formGroup.find('.invalid-feedback');

            var checks = {
                length: pwdVal.length >= MIN_LENGTH,
                upper: /[A-Z]/.test(pwdVal),
                lower: /[a-z]/.test(pwdVal),
                number: /\d/.test(pwdVal),
                special: /[^A-Za-z0-9]/.test(pwdVal)
            };

            $cache.pwdLength.toggleClass(cssConstants.SHOW_BLOCK, !checks.length);
            $cache.pwdUpper.toggleClass(cssConstants.SHOW_BLOCK, !checks.upper);
            $cache.pwdLetter.toggleClass(cssConstants.SHOW_BLOCK, !checks.lower);
            $cache.pwdNumber.toggleClass(cssConstants.SHOW_BLOCK, !checks.number);
            $cache.pwdSpecial.toggleClass(cssConstants.SHOW_BLOCK, !checks.special);

            renderStrength(getStrength(pwdVal, checks));

            // New password must differ from the current one (mirrors server rule).
            var sameAsCurrent = $cache.currentPasswordField.length
                && pwdVal.length > 0
                && pwdVal === $cache.currentPasswordField.val();

            if ($cache.passwordHelperList.children('.' + cssConstants.SHOW_BLOCK).length) {
                $cache.passwordHelper.removeClass(cssConstants.HIDDEN);
                $cache.passwordField.addClass(cssConstants.INVALID).removeClass(cssConstants.VALID);
                $formGroup.addClass(cssConstants.INVALID);
                $fieldError.addClass(cssConstants.HIDDEN);
            } else if (sameAsCurrent) {
                $cache.passwordHelper.addClass(cssConstants.HIDDEN);
                $cache.passwordField.addClass(cssConstants.INVALID).removeClass(cssConstants.VALID);
                $formGroup.addClass(cssConstants.INVALID);
                $fieldError.text($cache.passwordField.data('sameascurrent-error')).removeClass(cssConstants.HIDDEN);
            } else {
                $cache.passwordHelper.addClass(cssConstants.HIDDEN);
                $cache.passwordField.removeClass(cssConstants.INVALID).addClass(cssConstants.VALID);
                $formGroup.removeClass(cssConstants.INVALID);
                $fieldError.addClass(cssConstants.HIDDEN);
            }
        });
    }
};
